import { render, staticRenderFns } from "./singleChoiceOption.vue?vue&type=template&id=0fea24be&scoped=true"
import script from "./singleChoiceOption.vue?vue&type=script&lang=js"
export * from "./singleChoiceOption.vue?vue&type=script&lang=js"
import style0 from "./singleChoiceOption.vue?vue&type=style&index=0&id=0fea24be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fea24be",
  null
  
)

export default component.exports